import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopunedailycab() {



const cardData = {
  keyword: " Mumbai to Pune Daily Cabs",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Pune daily cab services, designed for commuters, business travelers, and frequent passengers seeking convenience and efficiency. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling between Mumbai and Pune smooth and stress-free every day. We offer flexible daily travel plans, transparent pricing with no hidden charges, and a fleet of air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking, recurring trip options, and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai to Pune daily cab travel.",

topPlaces: [
 
  {
    title: "Saras Baug",
    description: "Saras Baug is a well-known garden in Pune featuring lush green spaces and the famous Siddhivinayak Temple. It is a favorite spot for families, walkers, and visitors seeking relaxation in the city."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a riverside park offering greenery, walking tracks, and boating facilities. It is a peaceful location for evening strolls and leisure activities in Pune."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases a rich collection of Indian artifacts, including sculptures, musical instruments, and cultural items that reflect India’s heritage and traditions."
  },
   {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered spiritual landmarks dedicated to Lord Ganesha. Devotees and travelers can experience divine blessings, beautifully decorated idols, and a vibrant atmosphere, especially during major festivals like Ganesh Chaturthi."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification in Pune that once served as the seat of the Peshwas of the Maratha Empire. Visitors can explore its grand gateways, ruins, and enjoy the evening light and sound show that narrates Pune’s royal history."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden is a serene Japanese-style garden featuring lush greenery, water streams, and beautifully designed walking paths. It is an ideal place for relaxation, photography, and peaceful nature walks."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a historically significant monument linked to India’s freedom movement. It features elegant architecture, spacious gardens, and a museum dedicated to Mahatma Gandhi and important historical events."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a popular heritage site in Pune offering panoramic city views from its hilltop temples. Visitors can climb the steps to explore ancient shrines and enjoy a peaceful, scenic environment."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a popular shopping and entertainment hub featuring international brands, restaurants, cinemas, and entertainment zones, making it ideal for leisure and shopping experiences."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It is known for its spiritual ambiance and historical significance in Pune."
  }
],



services: [
{
name: "Mumbai to Bhosari Cab Service",
description: "Mumbai to Bhosari cab service provides reliable intercity transportation between Mumbai and the Bhosari area of Pimpri Chinchwad. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth travel through the Mumbai–Pune Expressway. Professional drivers provide punctual pickup from homes, offices, railway stations, hotels, and airport terminals across Mumbai. This service is ideal for business travelers, factory employees, and families visiting PCMC industrial areas. Air-conditioned vehicles ensure comfortable highway journeys while spacious luggage capacity makes the ride convenient for travelers. Flexible booking options allow passengers to schedule rides easily for both one-way and round-trip journeys."
},
{
name: "Mumbai to Camp Pune Cab",
description: "Mumbai to Camp Pune cab service offers dependable transportation between Mumbai and Pune Camp area. Comfortable vehicles including sedan, Ertiga, and Innova ensure smooth expressway travel for passengers heading to central Pune. Professional drivers provide safe driving and timely pickup services from homes, offices, and hotels across Mumbai. This taxi service is suitable for corporate travelers, tourists visiting Pune city, and families traveling for personal trips. Spacious vehicles provide relaxed seating and luggage capacity for long-distance journeys. Flexible booking options allow travelers to easily reserve rides according to their schedule."
},
{
name: "Mumbai to Sinhagad Road Cab",
description: "Mumbai to Sinhagad Road cab service provides convenient transportation between Mumbai and Pune’s Sinhagad Road area. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth expressway travel with experienced drivers handling the highway route safely. Pickup services are available from homes, offices, and hotels across Mumbai. This cab service is ideal for travelers visiting residential areas, educational institutes, or tourist destinations near Sinhagad Road. Air-conditioned vehicles ensure comfortable long-distance travel with convenient luggage space. Advance booking options make the journey easy to plan."
},
{
name: "Mumbai to Hinjewadi Taxi Fare",
description: "Mumbai to Hinjewadi taxi fare service provides transparent pricing for passengers traveling from Mumbai to Pune’s IT hub Hinjewadi. Comfortable vehicles ensure smooth highway travel through the Mumbai–Pune Expressway. Professional drivers provide safe driving and punctual pickup services from homes, offices, railway stations, and airport terminals across Mumbai. The service is ideal for IT professionals, corporate travelers, and business visitors heading to Hinjewadi IT Park. Clear pricing helps passengers plan their trip without hidden charges."
},
{
name: "Mumbai to Wakad Cab",
description: "Mumbai to Wakad cab service offers reliable transportation between Mumbai and Wakad in Pimpri Chinchwad. Comfortable vehicles such as sedan, Ertiga, and Innova ensure safe and smooth highway travel. Professional drivers provide punctual pickup services across Mumbai including residential areas, hotels, and railway stations. Ideal for business travel, family visits, and corporate trips. Spacious interiors and air-conditioned vehicles ensure comfortable long-distance journeys for passengers."
},
{
name: "Mumbai to Aundh Daily Cab Fare",
description: "Mumbai to Aundh daily cab fare service provides economical travel options for passengers commuting frequently between Mumbai and Aundh in Pune. Comfortable vehicles ensure smooth highway travel while professional drivers provide punctual pickup services. Ideal for corporate employees, consultants, and travelers visiting offices in Aundh. Clear daily fare pricing helps frequent travelers plan their intercity trips conveniently."
},
{
name: "Mumbai to Koregaon Park Daily Cab Fare",
description: "Mumbai to Koregaon Park daily cab fare service offers transparent pricing for travelers commuting regularly between Mumbai and Pune’s Koregaon Park area. Comfortable vehicles ensure smooth expressway travel with professional drivers providing punctual pickup services. Ideal for corporate travel, hotel visits, and residential travel to Koregaon Park. Air-conditioned vehicles ensure comfortable long-distance journeys."
},
{
name: "Mumbai to Pune Daily Innova Fare",
description: "Mumbai to Pune daily Innova fare service provides premium SUV travel for passengers commuting frequently between Mumbai and Pune. Toyota Innova and Innova Crysta vehicles offer spacious seating and smooth highway performance. Professional drivers ensure safe travel and punctual pickups from homes, offices, and railway stations across Mumbai. Ideal for families, corporate travel, and group journeys."
},
{
name: "Mumbai to Pune Daily Ertiga Fare",
description: "Mumbai to Pune daily Ertiga fare service provides comfortable 7-seater SUV transportation for passengers traveling frequently between the two cities. The Ertiga vehicle offers spacious seating and smooth highway travel. Professional drivers ensure safe driving and punctual pickup services from Mumbai locations."
},
{
name: "Mumbai to Pune Daily Sedan Cab Fare",
description: "Mumbai to Pune daily sedan cab fare service provides economical transportation using vehicles like Swift Dzire, Etios, and Xcent. These sedans are ideal for individuals and small families commuting regularly between Mumbai and Pune. Professional drivers ensure safe highway travel while offering punctual pickup services."
},
{
name: "Mumbai Pune Daily Cab Service",
description: "Mumbai Pune daily cab service offers regular transportation between the two major cities through the Mumbai–Pune Expressway. Comfortable vehicles ensure safe and smooth travel for daily commuters and business travelers. Professional drivers provide punctual pickup services and reliable long-distance transportation."
},
{
name: "Mumbai to Pimpri Daily Cab",
description: "Mumbai to Pimpri daily cab service provides reliable transportation between Mumbai and Pimpri in the PCMC region. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth highway travel. Ideal for corporate travelers and daily commuters traveling between the two cities."
},
{
name: "Cheapest Cab Mumbai to Pune",
description: "Cheapest cab Mumbai to Pune service offers affordable transportation options for passengers seeking budget-friendly intercity travel. Comfortable vehicles ensure safe highway journeys while professional drivers provide punctual pickup services. Flexible booking options help passengers reserve economical rides easily."
},
{
name: "Mumbai Airport to Pune Daily Cab Service",
description: "Mumbai Airport to Pune daily cab service offers dependable airport transportation between Chhatrapati Shivaji Maharaj International Airport and Pune city. Comfortable vehicles ensure smooth expressway travel while professional drivers provide punctual pickups from airport terminals."
},
{
name: "Mumbai Airport to Viman Nagar Cab Service",
description: "Mumbai Airport to Viman Nagar cab service provides reliable airport transfers between Mumbai Airport and Pune’s Viman Nagar area. Comfortable vehicles ensure smooth highway travel with experienced drivers handling the long-distance route safely."
},
{
name: "Mumbai Airport to Pune Taxi Fare",
description: "Mumbai Airport to Pune taxi fare service provides transparent pricing for passengers traveling between Mumbai Airport and Pune city. Travelers can choose from sedan, Ertiga, and Innova vehicles depending on comfort needs."
},
{
name: "Top Rated Cab Service in Mumbai",
description: "Top rated cab service in Mumbai provides reliable transportation with professional drivers and well-maintained vehicles for city rides, airport transfers, and outstation travel. Comfortable vehicles ensure smooth journeys for passengers traveling within Mumbai and nearby cities."
},
{
name: "Best Outstation Cab Service in Mumbai",
description: "Best outstation cab service in Mumbai offers dependable long-distance transportation from Mumbai to cities like Pune, Nashik, Lonavala, and Shirdi. Comfortable vehicles and experienced drivers ensure safe highway journeys."
},
{
name: "Mumbai Airport to Pune Cab Hinjewadi",
description: "Mumbai Airport to Pune Hinjewadi cab service provides convenient airport transportation between Mumbai Airport and Pune’s IT hub Hinjewadi. Comfortable vehicles ensure smooth highway travel for corporate travelers."
},
{
name: "Mumbai Airport to Pune Cab Wakad",
description: "Mumbai Airport to Pune Wakad cab service provides reliable airport transportation between Mumbai Airport and Wakad in Pimpri Chinchwad. Comfortable vehicles ensure smooth expressway journeys."
},
{
name: "Mumbai Airport to Pune Cab Kharadi",
description: "Mumbai Airport to Pune Kharadi cab service offers dependable airport transfers between Mumbai Airport and Pune’s IT hub Kharadi. Comfortable vehicles and professional drivers ensure safe travel."
},
{
name: "Mumbai Airport to Pune Cab Baner",
description: "Mumbai Airport to Pune Baner cab service provides convenient airport transportation between Mumbai Airport and Baner in Pune. Professional drivers ensure smooth highway journeys."
},
{
name: "Mumbai Airport to Pune Cab Pimpri Chinchwad",
description: "Mumbai Airport to Pimpri Chinchwad cab service offers reliable airport transportation between Mumbai Airport and the PCMC region including Pimpri and Chinchwad."
},
{
name: "Mumbai to Pune Taxi",
description: "Mumbai to Pune taxi service provides dependable intercity transportation between the two cities with comfortable vehicles and professional drivers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Mumbai."
}
],

tableData: [
["Mumbai to Bhosari Cab Service","Mumbai to Camp Pune Cab"],
["Mumbai to Sinhagad Road Cab","Mumbai to Hinjewadi Taxi Fare"],
["Mumbai to Wakad Cab","Mumbai to Aundh Daily Cab Fare"],
["Mumbai to Koregaon Park Daily Cab Fare","Mumbai to Pune Daily Innova Fare"],
["Mumbai to Pune Daily Ertiga Fare","Mumbai to Pune Daily Sedan Cab Fare"],
["Mumbai Pune Daily Cab Service","Mumbai to Pimpri Daily Cab"],
["Cheapest Cab Mumbai to Pune","Mumbai Airport to Pune Daily Cab Service"],
["Mumbai Airport to Viman Nagar Cab Service","Mumbai Airport to Pune Taxi Fare"],
["Top Rated Cab Service in Mumbai","Best Outstation Cab Service in Mumbai"],
["Mumbai Airport to Pune Cab Hinjewadi","Mumbai Airport to Pune Cab Wakad"],
["Mumbai Airport to Pune Cab Kharadi","Mumbai Airport to Pune Cab Baner"],
["Mumbai Airport to Pune Cab Pimpri Chinchwad","Mumbai to Pune Taxi"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Daily Route Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly operate daily cab services between Mumbai and Pune via the Mumbai Pune Expressway. Their familiarity with highway routes and traffic conditions ensures safe and punctual travel."
  },
  {
    WhyChooseheading: "Affordable Daily Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers competitive and transparent pricing for Mumbai to Pune daily cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming their ride."
  },
  {
    WhyChooseheading: "24/7 Daily Cab Availability",
    WhyChoosedescription: "Our Mumbai to Pune daily cab service operates round the clock. Whether you need a morning commute, corporate travel, or late-night ride, Velocity Cabs ensures reliable transportation every day."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable travel experience for passengers traveling daily between Mumbai and Pune."
  },
  {
    WhyChooseheading: "Flexible One Way & Daily Travel Options",
    WhyChoosedescription: "Velocity Cabs offers flexible daily travel options including one-way cab service, corporate travel plans, airport transfers, and customized daily commute services between Mumbai and Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, airports, railway stations, and residential areas across Mumbai including Andheri, Bandra, Borivali, Dadar, Thane, and Navi Mumbai."
  },
  {
    WhyChooseheading: "Trusted Daily Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai to Pune daily cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity transportation service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Pune daily cab service?", answer: "Yes, Velocity Cabs provides reliable daily cab services between Mumbai and Pune for regular travelers and corporate commuters." },
  { question: "What is the distance between Mumbai and Pune?", answer: "The road distance between Mumbai and Pune is around 150 km and the journey usually takes about 3 to 4 hours depending on traffic conditions." },
  { question: "Is Mumbai to Pune daily cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Mumbai to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Mumbai to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Mumbai and Pune." },
  { question: "Do you provide pickup from Mumbai Airport?", answer: "Yes, our drivers provide pickup from Mumbai Airport, homes, hotels, offices, and railway stations across Mumbai." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai to Pune daily cab services online or through phone booking." },
  { question: "Do you provide drop service anywhere in Pune?", answer: "Yes, Velocity Cabs provides drop services across Pune including Baner, Hinjewadi, Wakad, Kharadi, Hadapsar, and Pimpri Chinchwad." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Joshi",
    feedback:
      "Daily travel from Mumbai to Pune has become very comfortable and reliable. The cab service is always on time, and the ride feels smooth even with a regular schedule.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Kulkarni",
    feedback:
      "Consistent Mumbai to Pune daily cab service has made commuting stress-free. The vehicle is always clean, and the journey remains safe and well-managed every day.",
    rating: 5
  }
];

































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Daily Cab Service | Velocity Cabs",
  "description": "Velocity Cabs offers reliable Mumbai to Pune daily cab service with professional drivers and affordable fares. Book daily one way or round trip taxis including Innova, Innova Crysta, Ertiga, and Sedan cabs for regular city commutes, office travel, and corporate trips. Enjoy safe, comfortable, and punctual rides with easy online booking from Mumbai to Pune daily.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};








  return (
    <div>
      <Helmet>
  <title>Mumbai to Pune Daily Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune daily cab with Velocity Cabs. Affordable daily one way & round trip taxis including Innova, Innova Crysta, Ertiga & Sedan for regular city commutes and corporate trips." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/42.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopunedailycab;